import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons/faCalendarRange';
import type { EventsWidgetModel } from 'src/models/EventsWidgetModel';
import { EventsWidgetModelImpl } from 'src/models/EventsWidgetModel/impl';
import type { EventsWidgetState } from 'src/models/TimeListWidgetState/schemas';

export const eventsWidgetDefinition: SelfOwnedWidgetDefinition<EventsWidgetState, EventsWidgetModel> = {
    type: 'events',
    nameKey: 'widgets::events::name',
    roles: ['widgets::events'],
    icon: faCalendarRange,
    category: 'widgets::categories::research',
    defaultDimensions: { h: 0.8, w: 0.33, x: 0.33, y: 0.1 },
    widgetClass: EventsWidgetModelImpl,
};
